import { CultureInfo } from '../culture-info.model';
import { CultureInfoGsw } from './gsw';

/**
 * @ignore
 */
export const CultureInfoGswLI: CultureInfo = {
  name: 'gsw-LI',
  displayName: 'Schwiizertüütsch (Liächteschtäi)',
  iso3LanguageCode: 'gsw',
  iso2LanguageCode: 'gsw',
  ietfLanguageTag: 'gsw-LI',
  parent: CultureInfoGsw
};
